import { render, staticRenderFns } from "./FormRinci.vue?vue&type=template&id=746dc5fc&scoped=true&"
import script from "./FormRinci.vue?vue&type=script&lang=js&"
export * from "./FormRinci.vue?vue&type=script&lang=js&"
import style0 from "./FormRinci.vue?vue&type=style&index=0&id=746dc5fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "746dc5fc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
